<template>
    <div >
  <top-navbar ></top-navbar>
  <div class=" mb-5  background_color">
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6    class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Employee<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span> Feedback </h6>

    <div  class="container-fluid">

        <b-modal :id="infoModal1.id" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" bottom>
                <template #modal-title>
                  <h3>Confirm !</h3>
                </template>
                <div class="d-block text-center">
                  <h5>Are you sure you want to Confirm ?</h5>
                </div>
                <hr>
                <template #modal-footer>
                  <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
                  <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
                </template>
              </b-modal>
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" class="w-100" style="max-width: 225px;">
    <b-form-input
      id="filter-input"
      v-model="filter"
      @input="loadMiinventory()"
      type="search"
      placeholder="Search"
      class="bdr-rad">
    </b-form-input>


    </b-input-group>
    <div style="margin-top: -5px;" class="ms-2" >
        <span class="custom-breadcrumb">Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</span>
    </div>

        </div>


      <div class="d-grid gap-2 d-md-flex justify-content-md-end ">


        <button   @click="QuestionCreate()"  class="btn btn-sm btn-outline-primary  mb-1 mt-0 bdr-rad">  Create Questionnaire</button>


      </div>
    </div>
   <div  class="card bdr-rad2 mt-1 shadow p-2  ">
    <div  class="card-body " >
      <div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>



  <div class="table-responsive">


    <b-table 
       responsive
  style="font-size: small;"
  class="table-hover"
  :items="all_datas"
   :fields="fields"
   :current-page="currentPage"
   head-variant="dark"
    :filter="filter"
     :filter-included-fields="filterOn"
       :sort-by.sync="sortBy"
       :sort-desc.sync="sortDesc"
       :sort-direction="sortDirection"
       show-empty
     small
   >
    
    >
<template #cell(number)="row">
         {{ row.index + 1 === 15 ? currentPage * 15 : (currentPage - 1)*15 + row.index + 1 }} 
      </template>
    

      <template #cell(actions)="row">

        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor"  @click="moreinfo(row.item.id)">View</a>
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==55"  @click="Inactive(row.item.id)">Inactive</a>
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==2"  @click="Active(row.item.id)">Published</a>
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==1"  @click="Confimmodel(row.item.id)">Confirm</a>
   
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==1" @click="Update(row.item.id)">Update</a>

  </div>
</div>


  

      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>



    <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4 ">
    
         <b-pagination 
      @change="pageChanged"
      v-model="currentPage"
      pills
      :total-rows="totalRows"
      :per-page="perPage"
     
      size="sm">
    </b-pagination>
    </b-col>


</div>
  </div>

  

</div>
</div>

<br><br>

</div>
  </div>

  <content-footer></content-footer>
</div>


  </template>

  <script>
   //import {   CButton, } from '@coreui/vue';
   //import httpClient from '@/axios';
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'




  export default {
    components :{

        TopNavbar,
        ContentFooter,

    },

      mounted(){
    this.loadMiinventory()
      },

      computed: {




      },

      data(){
      return{

        mcustomers:[],
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],

        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'code', label: 'Questionnaire Code', sortable: true,  },
          { key: 'questionnaire_name', label: 'Questionnaire Name', sortable: true  },
            { key: 'created_date', label: 'Created date', sortable: true  },
            { key: 'userchech', label: 'Show Type', sortable: true  },
          { key: 'status', label: 'Status', sortable: true  },
          { key: 'username', label: 'Created By', sortable: true ,  },
       
        


          { key: 'actions', label: 'Actions', class:'width-custom3', }
        ],

         infoModal1: {
        id: 'info-modal1',
        title: '',
        content: {},
      },
        isLoading: true,


      };
      },




     methods:{


       async Confirm(id) {


       try {
         const { data} = await  axios.get('/questions/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
window.location.reload();
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },


       async Inactive(id) {


       try {
         const { data} = await  axios.get('/questions/inactive?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
            window.location.reload();
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },
       async Active(id) {


       try {
         const { data} = await  axios.get('/questions/active?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',

           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
window.location.reload();
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }

       } catch (error) {
         console.log(error.response);
       }
     },

       async Confimmodel(id){
        this.infoModal1.content = id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);

      },

      pageChanged(newPage) {
      if (newPage !== this.previousPage) {
        console.log("Page changed to:", newPage);
        this.previousPage = newPage; // Update previous page tracker
        this.loadMiinventory(newPage);
      }
    },

      

  async moreinfo(id) {

    this.$router.push('/questions/view?id='+id);

  },
  async answer(id) {

    this.$router.push('/questions/answer?id='+id);

  },
  async QuestionCreate() {

  this.$router.push('/questions/create');

},
  async Update(id){
        this.$router.push('/questions/update?id='+id);
      },

      serchCustom(id) {

    this.filterOn = id;
    },

    // onFiltered(filteredItems) {
    //     // Trigger pagination to update the number of buttons/pages due to filtering
    //     this.totalRows = filteredItems.length
    //     this.currentPage = 1
    //   },

       async loadMiinventory(page = this.currentPage) {
          console.log("aaa");
      try {
       // this.isLoading = true;
        const { data } = await axios.get('/questions/index', {
          params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },








  }




  };

  </script>

  <style scoped>
  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }

  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #007bff;
      border-top: 2px solid #007bff;
      padding-bottom: 10px !important;
      padding-top: 10px !important;

      }
      .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;

      }
      .decoration{
      text-decoration: none;
      color:white !important;
    }
    .width7{
      width: 250px;
    }

    .custom-header {
  background-color: #63adfc !important;
  color: white !important;

}
.bdr-rad{
  border-radius: 12px;
}
.bdr-rad2{
  border-radius: 15px;
}


.bg-clr1{
  background-color: red !important;
}
 .mouse-cursor {
  cursor: pointer;
 }














  </style>
